import { render, staticRenderFns } from "./TokenHelp.vue?vue&type=template&id=7f2f66f2"
import script from "./TokenHelp.vue?vue&type=script&lang=js"
export * from "./TokenHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports